<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <modal name="login-modal" :height="'auto'" :width="500">
    <div class="login-view">
      <div class="login-header flex align-center">
        <h3>로그인</h3>
        <span class="close-btn" @click="closeModal"></span>
      </div>
      <div class="login-input">
        <input type="email" placeholder="아이디 (이메일)" class="email-input" v-model="id" />
        <input type="password" placeholder="비밀번호" class="password-input" v-model="password" />
        <div class="save-id-view flex">
          <div class="left">
            <p-check class="p-icon p-curve p-bigger" color="success">
              <i class="icon mdi mdi-check" slot="extra"></i>
              <span>아이디 저장</span>
            </p-check>
          </div>
          <div class="right">
            <span>비밀번호 찾기</span>
          </div>
        </div>
        <button class="login-btn" @click="login">로그인</button>
        <p>아직 고시락 회원이 아니신가요? <a>이메일 회원가입</a></p>
      </div>

      <div class="sns-login">
        <v-facebook-login-scope app-id="262712347171562" v-model="result" :login-options="{scope: 'email'}" @login="getLogin">
          <button
            slot-scope="scope"
            class="facebook-login"
            @click="scope.toggleLogin"
            @login="getLogin"
          >페이스북 로그인</button>
        </v-facebook-login-scope>
        <button class="naver-login">네이버 로그인</button>
        <button class="kakao-login">카카오 로그인</button>
      </div>

      <div class="manager-login">
        <p>원장님이신가요?</p>
        <button>원장님 사이트</button>
      </div>
    </div>
  </modal>
</template>

<script>
  // OR, use cherry-pick export (better consistency)
  import { VFBLoginScope } from 'vue-facebook-login-component'

  export default {
    name: 'LoginModal',
    components: {
      VFacebookLoginScope : VFBLoginScope
    },
    data () {
      return {
        id: '',
        password: '',
        result: null
      }
    },
    watch: {
      result (newVal, oldVal) {
        console.log(newVal, oldVal)
      }
    },
    methods: {
      async login () {
        await this.$store.dispatch('loginProcess', {
          userId: this.id,
          password: this.password
        })
        this.closeModal()
      },
      closeModal () {
        this.$modal.hide('login-modal')
      },
      getLogin (response) {
        console.log(response)
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";
  .login-view {
    padding: 4rem 0 2.8rem;
    .login-header {
      justify-content: space-between;
      padding: 0 4rem;
      h3 {
        font-size: 3rem;
      }
      .close-btn {
        padding: 2rem;
        background: url('../../assets/images/exit.png') no-repeat center;
      }
    }
    .login-input {
      padding: 1rem 4rem 2rem;
      border-bottom: 1px solid #eeeeee;
      .email-input, .password-input {
        display: block;
        width: 100%;
        border: 1px solid #cccccc;
        padding: 1.7rem 2rem 1.8rem;
        margin: 0.7rem 0;
      }

      .save-id-view {
        justify-content: space-between;
        align-items: center;
        padding: 1rem 0;
        .right {
          font-size:1.3rem;
          font-weight: bold;
        }
      }
      .login-btn {
        width: 100%;
        height: 5rem;
        background-color: @windows-blue;
        margin: 1rem 0;
        color: @white;
        font-weight: bold;
      }
      p {
        font-weight: bold;
        text-align: center;
        a {
          color: @windows-blue-two;
          text-decoration: underline;
        }
      }
    }
    .sns-login {
      padding: 2.5rem 4rem;
      border-bottom: 1px solid #eeeeee;

      button {
        width: 100%;
        height: 5rem;
        line-height: 5rem;
        font-weight: bold;
        position: relative;
        margin: 0.5rem 0;


        &:before {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 2.5rem;
        }
      }
      .facebook-login {
        background: #1877f2;
        color: @white;

        &:before {
          content: '';
          padding: 0.725rem 1.325rem;
          background: url('../../assets/images/ex-facebook.png') no-repeat center;
        }
      }
      .naver-login {
        background: #2db400;
        color: @white;

        &:before {
          content: '';
          padding: 0.725rem 1.325rem;
          background: url('../../assets/images/ex-naver.png') no-repeat center;
        }
      }
      .kakao-login {
        background: #ffcc00;
        color: @black;

        &:before {
          content: '';
          padding: 0.725rem 1.325rem;
          background: url('../../assets/images/ex-kakao-share.png') no-repeat center;
        }
      }
    }
    .manager-login {
      padding: 2.5rem 4rem 0;
      text-align: center;
      font-weight: bold;

      button {
        &:before {
          content: '';
          padding: 1.75rem 4.85rem;
          margin-right: 1rem;
          background: url('../../assets/images/ex-logo.png') no-repeat center;
          background-size: contain;
        }
        margin: 1rem;
        color: @windows-blue;
        width: 24rem;
        height: 100%;
        border-radius: 2.5rem;
        line-height: 5rem;
        border: 2px solid @windows-blue;
        font-weight: bold;
      }
    }
  }
</style>
<style lang="less">
  @import "../../assets/css/palette";
  .login-view .pretty .state.p-success label span {
    font-weight: bold;
    font-size:1.3rem;
  }
  .login-view .pretty input:checked ~ .state.p-success label:after,
  .login-view .pretty.p-toggle .state.p-success label:after {
    background-color: @windows-blue !important;
  }
</style>
